var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.armasPersonal),function(arma,index){return _c('v-list-item',{key:index},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(arma.Arma.matricula)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(arma.Arma.CatClase.CatTipo.title)+" ")])],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }